// extracted by mini-css-extract-plugin
module.exports = {"Title":"EventSignatureImage_Title__wyJT7","Content":"EventSignatureImage_Content__2X2fn","SignatureImage":"EventSignatureImage_SignatureImage__1ubtQ"};